export default "__VITE_ASSET__CS_F7bb$__$_?url__"